import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface OfflineMessageEmojiProps {
  emoji: string;
}

const EmojiComponent: React.FC<OfflineMessageEmojiProps> = ({ emoji }) => {
  return <div className="offline-icon">{emoji}</div>;
};

export const Emoji: React.FC<OfflineMessageEmojiProps> = (
  props: OfflineMessageEmojiProps
) => {
  const Component = useCustomComponent({
    componentName: 'OfflineMessageEmoji',
    Component: EmojiComponent,
  });

  return <Component {...props} />;
};
